import { render, staticRenderFns } from "./batchUpload.vue?vue&type=template&id=28f0016c&scoped=true"
import script from "./batchUpload.vue?vue&type=script&lang=js"
export * from "./batchUpload.vue?vue&type=script&lang=js"
import style0 from "./batchUpload.vue?vue&type=style&index=0&id=28f0016c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f0016c",
  null
  
)

export default component.exports